import { render, staticRenderFns } from "./EditScope.vue?vue&type=template&id=fdedbfc8&"
import script from "./EditScope.vue?vue&type=script&lang=js&"
export * from "./EditScope.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports